import { useEffect } from 'react'
import { get } from '../api/api'
import { useAuthStore } from '../store/authStore'
import { useAppStore } from '../store/appStore'

import { EHRAdapterMap } from '../adapterConfig'

export const useAdapterInit = () => {
    const idToken = useAuthStore((state) => state.idToken)
    const orgModel = useAppStore((state) => state.orgModel)

    useEffect(() => {
        const fetchAdapterStatus = async () => {
            if (!orgModel?.ehr_adapter) {
                useAppStore.setState({
                    isAdapterConnected: false,
                })
                return
            }

            try {
                const adapterName = EHRAdapterMap[orgModel.ehr_adapter]?.toLowerCase()
                const isAdapterConnected = await get<boolean>(`/adapters/${adapterName}/connected`)
                useAppStore.setState({
                    isAdapterConnected,
                })
            } catch (err: unknown) {
                console.error('Failed to load integration status:', err)
            }
        }
        fetchAdapterStatus()
    }, [orgModel])

    useEffect(() => {
        if (!idToken) {
            useAppStore.setState({
                isAdapterConnected: false,
            })
        }
    }, [idToken])
}
